// простая функция для получения значения флага SberID без использования хуков

const getSberIdFlag = (): boolean => {
  if (typeof window === 'undefined') return false

  try {
    // проверяем URL параметры
    const urlParams = new URLSearchParams(window.location.search)
    const featureFlags = urlParams.get('featureFlags')

    if (featureFlags) {
      const flags = featureFlags.split(',')
      return flags.includes('SberID')
    }

    // проверяем localStorage как fallback
    const storedFlags = localStorage.getItem('featureFlags')
    if (storedFlags) {
      try {
        const flags = JSON.parse(storedFlags)
        return flags['SberID'] === true
      } catch (e) {
        console.warn('Ошибка парсинга featureFlags из localStorage:', e)
      }
    }

    return false
  } catch (error) {
    console.warn('Ошибка при получении флага SberID:', error)
    return false
  }
}

export default getSberIdFlag
